'use client';

import { useEffect, useSyncExternalStore } from 'react';
import { useOptionalProduct } from '@/contexts/ProductContext';
import { useYotpoRefresh } from '@/lib/hooks/useYotpoRefresh';

const PRODUCT_REVIEWS_INSTANCE_ID = '817757';
const STORE_BASE_URL = 'https://birchliving.com';
const REVIEWS_ANCHOR = 'yotpo_product_reviews';

const YotpoProductReviewsClient = () => {
  const product = useOptionalProduct();
  const productData = product?.productData;
  const shopifyProductId = productData?.shopify_product_id;
  const shopifyProduct = productData?.shopifyProduct;
  const mounted = useSyncExternalStore(() => () => {}, () => true, () => false);
  const shouldRenderWidget = mounted && Boolean(shopifyProductId);

  useEffect(() => {
    if (!mounted) return;
    if (window.location.hash !== `#${REVIEWS_ANCHOR}`) return;

    let attempts = 0;
    const MAX_ATTEMPTS = 20;

    const tryScroll = () => {
      const el = document.getElementById(REVIEWS_ANCHOR);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      if (attempts++ < MAX_ATTEMPTS) setTimeout(tryScroll, 150);
    };

    tryScroll();
  }, [mounted]);

  useYotpoRefresh(shouldRenderWidget);

  if (!mounted) return <div className="min-h-[400px]" />;
  if (!shopifyProductId) return null;

  const productUrl = productData?.url
    ? `${STORE_BASE_URL}${productData.url}`
    : undefined;
  const priceAmount =
    shopifyProduct?.priceRange?.minVariantPrice?.amount ?? undefined;
  const priceCurrency =
    shopifyProduct?.priceRange?.minVariantPrice?.currencyCode ?? undefined;

  return (
    <div
      className="yotpo-widget-instance"
      data-yotpo-instance-id={PRODUCT_REVIEWS_INSTANCE_ID}
      data-yotpo-product-id={shopifyProductId}
      data-yotpo-name={shopifyProduct?.title}
      data-yotpo-url={productUrl}
      data-yotpo-image-url={shopifyProduct?.featuredImage?.url}
      data-yotpo-price={priceAmount}
      data-yotpo-currency={priceCurrency}
    />
  );
};

export default YotpoProductReviewsClient;
